import React, { useState } from "react";
import VideoEdit from "./VideoEdit"; // Import the VideoEdit modal
import "./index.scss";

// Helper function to format the duration in hours, minutes, and seconds
const formatDuration = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return `${hrs > 0 ? `${hrs}h ` : ''}${mins}m ${secs}s`;
};

const VideoBox = ({ video, onClick, isOwner, studioId, type }) => {
  const [openEditModal, setOpenEditModal] = useState(false);

  // Ensure duration is available, otherwise fallback to "N/A"
  const formattedDuration = video.duration ? formatDuration(video.duration) : 'N/A';

  // Function to open the edit modal
  const handleOpenEditModal = (e) => {
    e.stopPropagation(); // Prevent triggering video selection
    console.log("Edit button clicked for:", video.title || "Untitled Video", "| Type:", type);
    setOpenEditModal(true);
  };

  // Function to close the edit modal
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
  };

  // Function to handle media item click
  const handleMediaClick = () => {
    console.log("Media item clicked:", { title: video.title, url: video.url, type });
    onClick(video);
  };

  return (
    <div className="video-item" onClick={handleMediaClick}>
      {/* Video Thumbnail with fallback */}
      <img src={video.thumbnailImg || 'path/to/default-thumbnail.png'} alt={video.title || 'Untitled Video'} className="video-thumbnail" />
      
      {/* Video Title with fallback */}
      <div className="video-title">{video.title || 'Untitled Video'}</div>
      
      {/* Video Info */}
      <div className="video-info">
        <span>{new Date(video.createdAt).toLocaleDateString()}</span>
        <span>{formattedDuration}</span>
      </div>

      {/* Conditionally render the Edit button if the user is the owner */}
      {isOwner && (
        <button className="edit-button" onClick={handleOpenEditModal}>
          Edit
        </button>
      )}

      {/* Render the VideoEdit modal */}
      <VideoEdit
        open={openEditModal}
        handleClose={handleCloseEditModal}
        item={video}
        studioId={studioId}
        type={type}
      />
    </div>
  );
};

export default VideoBox;
